import { Alert } from "@mui/material";

export const RestrictedAccountAlert = ({isRestricted}) => {
    return isRestricted ? (
        <Alert variant="filled" severity="warning">Restricted - Privileged Account - Cannot Modify With Tech Tools</Alert>
    ) : null;
}